import SectionMsg from './SectionMsg.component';

export default SectionMsg;
